import request from '@/utils/request'
import base from "@/api/base";

export default {
    // 获取前台首页
    get: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/index`, params),
    //获取产样色卡
    update: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/getProductColorcard`, params),
    //获取产样详情
    add: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/product/getProductDetail`, params),
    //产样分类列表
    getfl: () => request.get(`${base.baseUrl}/yyyhao-cloud-product/front/product/getCategoryList`),
    //关注用户
    gz: params => request.post(`${base.baseUrl}/yyyhao-cloud-member/front/member/changeFollow`, params),
    //获取面料适用
    getml: () => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/member/getFabricApplyList`),
    //获取主营产品
    getzy: () => request.get(`${base.baseUrl}/yyyhao-cloud-member/front/member/getMainProductList`),

    //获取公司简介图片
    getProfileList: params => request.post(`${base.baseUrl}/yyyhao-cloud-product/front/profile/getProfileList`, params),
}